import { QuestionnaireConfig } from '@/types';

export type QuestionnaireSendTimeUnit = QuestionnaireConfig['sendTimeUnit'];

export const QUESTIONNAIRE_TIME_UNITS: Array<{ value: QuestionnaireSendTimeUnit; label: string }> =
  [
    { value: 'hours', label: 'Hours Prior' },
    { value: 'days', label: 'Days Prior' }
  ];

export const isQuestionnaireSendTimeUnit = (value: string): value is QuestionnaireSendTimeUnit =>
  value === 'hours' || value === 'days';

export type TierPrices = NonNullable<import('@/types').Service['tierPrices']>;

export const applyTierPrice = (
  current: TierPrices | undefined,
  tier: keyof TierPrices,
  value: string
): TierPrices => {
  const next = { ...(current || {}) } as TierPrices;
  if (value === '') {
    delete next[tier];
  } else {
    next[tier] = Number(value);
  }
  return next;
};
